import './PrintInstructions.css';

/**
 * Print instructions page that appears as the first page of generated PDFs.
 * The card-backs-instructions section is always rendered but visibility is
 * controlled by generatePdf() based on whether card backs are enabled.
 */
export function PrintInstructions() {
  return (
    <div className="print-instructions">
      <h1>Print Settings</h1>
      
      <p className="intro">
        Configure your printer's dialog with these settings for best results.
      </p>

      <div className="settings-grid">
        <div className="setting">
          <h2>Paper Size</h2>
          <p className="value">Letter (8.5" × 11")</p>
        </div>

        <div className="setting">
          <h2>Orientation</h2>
          <p className="value">Portrait</p>
        </div>

        <div className="setting">
          <h2>Margins</h2>
          <p className="value">None / Minimum</p>
          <p className="note">The cards have built-in margins</p>
        </div>

        <div className="setting">
          <h2>Scale</h2>
          <p className="value">100%</p>
          <p className="note">Do not use "Fit to page"</p>
        </div>

        <div className="setting">
          <h2>Background Graphics</h2>
          <p className="value">Enabled</p>
          <p className="note">Required for border colors</p>
        </div>

        <div className="setting">
          <h2>Headers & Footers</h2>
          <p className="value">Disabled</p>
        </div>
      </div>

      <div className="tips">
        <h2>Tips</h2>
        <ul>
          <li>Cards are laid out 9 per page (3×3 grid)</li>
          <li>Each card is standard playing card size (2.5" × 3.5")</li>
          <li>Use cardstock (110 lb) for durability</li>
          <li>Print this PDF directly without any additional scaling</li>
        </ul>
      </div>

      {/* Visibility controlled by generatePdf() based on cardBackOptions.enabled */}
      <div className="card-backs-instructions" style={{ display: 'none' }}>
        <h2>Double-Sided Printing (Card Backs)</h2>
        <p className="intro">
          This PDF includes card backs interleaved with fronts, formatted for double-sided printing.
        </p>
        <ul>
          <li>Pages alternate: fronts, backs, fronts, backs (e.g., page 2 = fronts 1-9, page 3 = backs 1-9)</li>
          <li>Backs are mirrored horizontally so they align when printed duplex</li>
          <li>Enable <strong>"Flip on long edge"</strong> in your printer's duplex settings</li>
          <li>If your printer doesn't support duplex: print odd pages first, then reload the paper face-up without flipping it, and print even pages</li>
          <li>Do a test print with a few cards first to verify alignment</li>
        </ul>
      </div>
    </div>
  );
}
